module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/approvance/approvance-grid/approvance-grid.component.css
// module id = ./src/app/finance/approvance/approvance-grid/approvance-grid.component.css
// module chunks = main